<template>
  <div class="slider-container">
    <v-responsive aspect-ratio="2.5" class="rounded-xl overflow-hidden skeleton-wrapper" v-if="loading">
      <v-skeleton-loader type="image" class="fill-height custom-skeleton"></v-skeleton-loader>
    </v-responsive>

    <v-carousel
      v-else-if="slides && slides.length > 0"
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="mdi-minus"
      :hide-delimiters="slides.length <= 1"
      cycle
      height="auto"
      class="rounded-xl main-slider"
      interval="6000">
      <v-carousel-item v-for="(slide, i) of slides" :key="i + '-slide'" @click="handleClick(slide)" class="slider-item">
        <v-img
        contain
          :src="'/img/' + slide.image"
          aspect-ratio="2.94"
          class="slider-img"
          gradient="to bottom, rgba(0,0,0,0) 40%, rgba(0,0,0,0.2) 70%, rgba(0,0,0,0.9) 100%">
          <div class="slider-content pa-4">
            <v-chip v-if="slide.isParty" color="red accent-3" text-color="white" small class="font-weight-black pulse-animation mb-1">
              EVENT 🔥
            </v-chip>

            </h3>
          </div>
        </v-img>
      </v-carousel-item>
    </v-carousel>

    <party-overlay v-model="showPartyOverlay" :party="selectedParty" :user="user"></party-overlay>
  </div>
</template>

<script>
import api from "@/api"
import socketService from "@/socketService"
import PartyOverlay from "@/components/home/partyOverlay.vue"

export default {
  name: "HomeTopSlider",
  components: { PartyOverlay },
  data() {
    return {
      loading: true,
      slides: [],
      showPartyOverlay: false,
      selectedParty: null,
      user: JSON.parse(localStorage.getItem("user") || "{}"),
    }
  },
  async created() {
    this.setupSocketListeners()
    await this.loadSliderContent()
    this.loading = false
  },
  beforeDestroy() {
    socketService.off("slide_changed")
    socketService.off("slide_created")
  },
  methods: {
    async loadSliderContent() {
      // 1. Parties laden (für das Overlay)
      let parties = []
      try {
        parties = await api.fetchParties()
        parties = parties.map((p) => ({ ...p, isParty: true }))
      } catch (e) {
        console.error("Parties failed", e)
      }

      // 2. Normale Slides laden
      let standardSlides = []
      try {
        // Parallel laden für Speed
        const [events, main] = await Promise.all([api.fetchEventsForSlider(), api.fetchMainSlider()])
        standardSlides = [...events, ...main]
      } catch (e) {
        console.error("Slides failed", e)
      }

      // 3. Mischen
      this.slides = [...parties, ...standardSlides]
    },

    handleClick(slide) {
      if (slide.isParty) {
        this.selectedParty = slide
        this.showPartyOverlay = true
      } else {
        const link = slide.link
        if (link) {
          if (link.includes("http")) {
            window.open(link, "_blank").focus()
          } else {
            this.$router.push(link)
          }
        }
      }
    },

    // Echtzeit-Updates beibehalten
    setupSocketListeners() {
      socketService.on("slide_changed", (data) => {
        if (data.slide) this.handleSlideUpdate(data.slide)
      })
      socketService.on("slide_created", (data) => {
        if (data.slide) this.handleSlideUpdate(data.slide)
      })
    },

    handleSlideUpdate(slide) {
      // Logik zum Aktualisieren der Slides ohne Reload
      const index = this.slides.findIndex((s) => s._id === slide._id)
      if (index !== -1) {
        this.$set(this.slides, index, slide)
      } else {
        this.slides.push(slide)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* Container Styles */
.slider-container {
  position: relative;
  width: 100%;
}

/* Slider Shadow & Radius */
.main-slider {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.6) !important;
  transition: transform 0.2s;

  &:active {
    transform: scale(0.98);
  }
}

/* Skeleton Dark Mode Fix */
.custom-skeleton {
  background: rgba(255, 255, 255, 0.05) !important;
}
::v-deep .v-skeleton-loader__image {
  height: 100%;
  background: rgba(255, 255, 255, 0.05) !important;
}

/* Content Overlay Positioning */
.slider-content {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 2;
}

.text-shadow {
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.8);
}

/* Animations */
.pulse-animation {
  animation: pulse-red 2s infinite;
  box-shadow: 0 0 0 0 rgba(255, 23, 68, 0.7);
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 23, 68, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 23, 68, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 23, 68, 0);
  }
}

/* Vuetify Overrides für cleaneren Look */
::v-deep .v-carousel__controls {
  background: transparent;
  padding-bottom: 8px;

  .v-btn--active {
    color: white !important;
    transform: scale(1.2);
  }
  .v-btn {
    color: rgba(255, 255, 255, 0.5) !important;
  }
}
</style>
